import { queryOptions } from '@tanstack/react-query';
import { registerBaseURL } from '#constants/hosts';
import { client, isResponseError } from '#queries/utils';
import {
  ApiGetKYCStatusResponse,
  type ApiKYCStatus,
} from '#proto/qonto/registration/kyc/firstparty/v1/get_kyc_status';

async function fetchRegisterKycStatus(stakeholderId: string): Promise<ApiKYCStatus | null> {
  const json = await client(`${registerBaseURL}/v1/kyc?stakeholder_id=${stakeholderId}`);
  return ApiGetKYCStatusResponse.fromJSON(json).kyc;
}

export const kycQueries = {
  all: ['register-kyc'] as const,
  item: (stakeholderId: string) =>
    queryOptions({
      queryKey: [...kycQueries.all, 'item', stakeholderId] as const,
      queryFn: () => fetchRegisterKycStatus(stakeholderId),
      // Don't retry on 404 — normal when no KYC exists for this stakeholder yet
      retry: (failureCount, error) => {
        if (isResponseError(error) && error.status === 404) return false;
        return failureCount < 3;
      },
    }),
};
